import {Component, Input, OnInit} from '@angular/core';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcCoreModule, ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-drawer-task-details',
  templateUrl: './drawer-task-details.component.html',
  styles: []
})
export class DrawerTaskDetailsComponent extends ExcTranslation implements OnInit {

  @Input() data: any | undefined = undefined;
  @Input() oeList: any[] | undefined = [];
  @Input() Schadenort: any | undefined = undefined;

  constructor(public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
  }

  getOEByID(ID: string): any {
    return ExcCoreModule.Array.GetObject(this.oeList, 'oeID', ID);
  }

}
